import axios from 'axios';

class AdminService {
    static addWedding = (body) => axios.post('/admin/add-wedding', body);

    static addGuest = (body) => axios.post('/admin/add-guest', body);

    static addTable = (body) => axios.post('/admin/add-table', body);

    static addFamily = (body) => axios.post('/admin/add-family', body);

    static getWeddingDetailsWithTablesAndGuests = (weddingId) => axios.get(`/admin/wedding-details/${weddingId}`);

    static getGuests = (weddingId) => axios.get(`/admin/guests/${weddingId}`);

    static updateWedding = (weddingId, body) => axios.put(`/admin/update-wedding/${weddingId}`, body);

    static updateGuest = (guestId, body) => axios.put(`/admin/update-guest/${guestId}`, body);

    static updateTable = (tableId, body) => axios.put(`/admin/update-table/${tableId}`, body);

    static editFamily = (familyId, body) => axios.put(`/admin/edit-family/${familyId}`, body);

    static setFamilyMemberStatus = (familyId, body) => axios.put(`/admin/set-family-member-status/${familyId}`, body);

    static setFamilyTable = (familyId, body) => axios.put(`/admin/set-family-table/${familyId}`, body);

    static deleteUserAndData = (userId) => axios.delete(`/admin/delete-user-and-data/${userId}`);

    static deleteGuest = (guestId) => axios.delete(`/admin/delete-guest/${guestId}`);

    static deleteTable = (tableId) => axios.delete(`/admin/delete-table/${tableId}`);

    static deleteFamily = (familyId) => axios.delete(`/admin/delete-family/${familyId}`);

    static uploadInvitation = (weddingId, formData) => axios.post(`/admin/upload-invitation/${weddingId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

    static deleteInvitation = (weddingId) => axios.delete(`/admin/delete-invitation/${weddingId}`);

    static createCheckoutSession = (body) => axios.post('/stripe/create-checkout-session', body);

    static createOneTimeCheckoutSession = (body) => axios.post('/stripe/create-one-time-checkout-session', body);

    static createOneTimeCheckoutSessionPaddle = (body) => axios.post('/paddle/create-one-time-checkout-session-paddle', body);

    static cancelSubscription = () => axios.post('/stripe/cancel-subscription');

    static reactivateSubscription = () => axios.post('/stripe/reactivate-subscription');

    static getNextInvoice = () => axios.get('/stripe/get-next-invoice');

    static downloadGuestsPDF = (weddingId) => axios.get(`/admin/download-guests-pdf/${weddingId}`, { responseType: 'blob' });
}

export default AdminService;
